import { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";

import { readCsvOrExcel } from "../../common/csv_utils";
import { useModalContext } from "../../contexts/ModalContext/context";
import { useSnackbar } from "../../hooks/useSnackbar";

export const useBlockedWordsUploadHandler = () => {
  const { setIsOpen } = useModalContext();
  const [uploadValues, setUploadValues] = useState([]);
  const { showErrorSnackbar } = useSnackbar();
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    accept: {
      // @ts-ignore
      "text/csv": [".csv"]
    },
  });

  useEffect(() => {
    if (!acceptedFiles) {
      return;
    }

    if (acceptedFiles.length > 1) {
      showErrorSnackbar("We can only accept one file");
      return;
    }

    if (acceptedFiles.length === 1) {
      readCsvOrExcel(acceptedFiles[0], setUploadValues, showErrorSnackbar);
    }
  }, [acceptedFiles]);

  useEffect(() => {
    if (uploadValues.length > 0) {
      setIsOpen(true);
    }
  }, [uploadValues]);

  return {
    acceptedFiles,
    uploadValues,
    getRootProps,
    getInputProps,
  };
};
